<section class="page about">
  <div class="container">
    <nav class="crumbs" aria-label="Breadcrumb">
      <ol><li><a routerLink="/">Home</a></li><li aria-current="page">About</li></ol>
    </nav>

    <header class="about__head" appReveal>
      <p class="eyebrow">ABOUT</p>
      <h1>A Maharashtra engineering company, two divisions, one workshop.</h1>
    </header>

    <div class="about__grid">
      <div appReveal>
        <p>Mechtron designs and builds waste water treatment plants — sewage and effluent —
          and calibrates the instruments that prove they are working. Both divisions run out of
          the same workshop in Vasai Virar, which is why one party stays responsible from process
          design through to commissioning.</p>
        <p>We take pride in sustainable, practical treatment: plants sized to the real load rather
          than to a catalogue, built from equipment we manufacture ourselves, and handed over
          running.</p>

        <h2>How a project runs</h2>
        <ol class="steps">
          <li><strong>Design</strong> Process design against your flow, load and discharge standard.</li>
          <li><strong>Manufacture</strong> Fabrication of the units in our own workshop.</li>
          <li><strong>Install</strong> Site erection, piping and electricals.</li>
          <li><strong>Commission</strong> Start-up, stabilisation and handover.</li>
        </ol>
      </div>

      <aside class="facts" appReveal [revealDelay]="80">
        <h2>Company facts</h2>
        <dl>
          @for (f of facts; track f.label) {
            <dt>{{ f.label }}</dt><dd>{{ f.value }}</dd>
          }
        </dl>
      </aside>
    </div>
  </div>
</section>
